<div class="flex w-full items-center gap-x-8 pr-48">
    <button
        interacta-icon-button
        type="button"
        [icon]="'chevron-small-left'"
        [label]="'SHARED.BUTTON.BACK' | translate"
        [style]="'text'"
        (click)="back.emit()"
    ></button>

    <div class="line-clamp-3 flex-1 text-center typo-sm-bold wrap-break-word">
        {{ label() }}
    </div>
</div>
